import { css } from 'emotion'

export const marginTopLargeStyles = css`
  margin-top: 32px;
`
